const initCheckAll = (form) => {
	const checkButtons = form.element.querySelectorAll('[data-check-all]');
	if (!checkButtons.length) return;

	const processCheckAll = (event) => {
		const checkButton = event.currentTarget;
		const fieldset = checkButton.closest('fieldset');
		if (fieldset.dataset.fieldType !== 'checkbox') return;

		const doCheckAll = checkButton.dataset.checkAll === 'true';
		const checkboxes = fieldset.querySelectorAll('input[type="checkbox"]');
		checkboxes.forEach(checkbox => {
			checkbox.checked = doCheckAll;
		});
	};

	checkButtons.forEach(checkButton => {
		checkButton.addEventListener('click', processCheckAll);
	});
};

export default initCheckAll;